import { render, staticRenderFns } from "./lamsRegLegalConsultApproval.vue?vue&type=template&id=42f94fbe&scoped=true&"
import script from "./lamsRegLegalConsultApproval.vue?vue&type=script&lang=js&"
export * from "./lamsRegLegalConsultApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f94fbe",
  null
  
)

export default component.exports